module.exports = __webpack_public_path__ + "img/NIKKO-IMG-03.fadc8940.jpg";